import { axios } from "@/core/axios";
import { WidgetTemplate, WidgetTemplateCategory } from "../types";

interface CategoryWithTemplates extends WidgetTemplateCategory {
    templates: Omit<WidgetTemplate, "category">[];
}

interface GetTemplatesResponse {
    templates: WidgetTemplate[];
    categories: WidgetTemplateCategory[];
}

export const widgetTemplateEndpoints = {
    getTemplates: async (): Promise<GetTemplatesResponse> => {
        try {
            const response = await axios.get<{ data: CategoryWithTemplates[] }>("/widget-templates");
            const rawCategories = response.data.data;

            // Extract categories (available even when templates arrays are empty)
            const categories: WidgetTemplateCategory[] = rawCategories
                .map(({ id, name, slug, sortOrder }) => ({ id, name, slug, sortOrder }))
                .sort((a, b) => a.sortOrder - b.sortOrder);

            // Flatten nested templates into WidgetTemplate[] with embedded category
            const templates: WidgetTemplate[] = rawCategories.flatMap((category) =>
                category.templates.map((template) => ({
                    ...template,
                    category: {
                        id: category.id,
                        name: category.name,
                        slug: category.slug,
                        sortOrder: category.sortOrder,
                    },
                })),
            );

            return { templates, categories };
        } catch (error) {
            console.error("Error fetching widget templates:", error);
            throw error;
        }
    },
};
